import axios  from "../../services/axios";
import { constants } from '../../constants';
export const listLoads = async ({ filters, page, perPage }) => {
  
  try {
    const response = await axios.get(`/load/list`, {
      params: {
        datetime: filters?.datetime || '',
        vanid: filters?.vanid || '',
        page,
        perPage,
      },
    });
  
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch loads. Please try again later.';
    throw new Error(message);
  }
  };
export const fetchVans = async () => {
  try {
    const response = await axios.get('van/list-all');
    return response.data; 
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch vans. Please try again later.';
    throw new Error(message);
  }
};
export const fetchLoadDetails = async (loadid) => {
  try {
  const response = await axios.get(`/load/details/${loadid}`);
  return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch load details. Please try again later.';
    throw new Error(message);
  }
};
export const createLoad = async (formData) => {
  try {
  const payload = new FormData();
  payload.append('datetime', formData.datetime);
  payload.append('vanid', formData.vanid);
  if (formData.file) {
    payload.append('file', formData.file);
  }

  const response = await axios.post('/load/add', payload);
  return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to create load. Please try again.';
    throw new Error(message);
  }
};
export const deleteLoad = async (id) => {
  try {
  const response = await axios.delete(`load/delete/${id}`);
  return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to delete load. Please try again.';
    throw new Error(message);
  }
};

export const updateBarcode = async ({id, newBarcode,loadid}) => {

  try {
    const response = await axios.patch(`load/update-barcode/${id}`, {
      barcode: newBarcode,
      loadid:loadid
    }

  );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to update barcode. Please try again.';
    throw new Error(message);
  }
};

export const downloadLoadDetails = async (loadid) => {
  try {
    const response = await axios.get(`/load/download/${loadid}`,
      {
        responseType: 'blob'
      }
    );
    return response.data;
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to fetch load details. Please try again later.';
    throw new Error(message);
  }
};
